import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { UserRole } from '../../enums/roles.enum';
import { CurrentUserService } from './services/user/current-user.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private currentUserService: CurrentUserService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          if (typeof window !== 'undefined') {
            window.location.href = `${environment.apiLocations.login}`;
          }
        }

        const currentUser = this.currentUserService.GetSession();
        if (currentUser?.role !== UserRole.Admin) {
          console.log('Auth Interceptor: Redirecting');
          window.location.href = environment.apiLocations.derm;
          return throwError(
            () => new Error('Unauthorized access for non-admin users.')
          );
        }

        return throwError(() => error);
      })
    );
  }
}
